import { Vue } from 'vue-class-component';
import { Terminal } from 'xterm';
import { FitAddon } from 'xterm-addon-fit';
import { WebLinksAddon } from 'xterm-addon-web-links';
import { LinkProvider } from 'xterm-link-provider';
import { TerminalModule } from '/@/store/enums';
import store from '/@/store/store';
import { links } from './functions/links';

export default class TerminalComponent extends Vue {
	term: any;
	fitAddon: any;
	command: string = '';
	path: string = '/';

	commands: any = {
		cd: {
			f: (terminal: any, self: any, parameter: string | undefined) => {
				console.log(parameter);
				switch (parameter) {
				case '/':
					self.path = '/';
					break;
				case '..':
					self.path = '/';
					break;
				case 'references':
					self.path = '/references';
					break;
				case undefined:
					self.prompt();
					break;
				default:
					self.prompt('cd: ' + parameter + ': No such directory' );
				}


				setTimeout(() => {
					self.prompt();
				}, 200);
			},
			description: 'Prints this help message',
		},
		cat: {
			f: (terminal: any, self: any, parameter: string | undefined) => {
				if (!parameter) {
					self.prompt(`Please, enter a parameter for 'cat'`);

					return;
				}

				if (self.path === '/') {
					switch (parameter) {
					case 'about_me.txt':
						terminal.write('Welcome to \x1b[34mMáté Borkesz\x1b[0m\'s CV site! Type \'help\' in the termimal and hit \'Enter\' for more information.');
						terminal.write('acilis sequi, sit officiis perferendis impedit, accusamus quibusdam eius, nisi laborum. Quas enim, beatae modi earum expedita alias, iste molestiae nulla, quasi pariatur ratione. Dolores voluptate aperiam error quod aspernatur blanditiis a labore architecto! Repellendus odio reprehenderit error ');
						self.prompt();
						break;
					default:
						self.prompt('cat: ' + parameter + ': No such file or directory' );
					}

					return;
				}

				self.prompt('cat: ' + parameter + ': No such file or directory' );
			},
		},
		help: {
			f: (terminal: any, self: any, parameter: string) => {
				self.prompt([
					'Use the commands listed below to navigate and read more about my skills and experience.',
					'ls', 'cd', 'cat', 'clear', 'pwd',
				].join('\n\r'));
			},
			description: 'Prints this help message',
		},
		pwd: {
			f: (terminal: any, self: any, parameter: string) => {
				self.prompt([
					'borkeszmate.hu' + self.path,
				].join('\n\r'));
			},
			description: 'Prints this help message',
		},

		ls: {
			f: (terminal: any, self: any, parameter: string) => {
				switch (self.path) {
				case '/':
					self.prompt([
						'references',
						'contributions',
						'about_me.txt',
					].join('\r\n'));
					break;
				case '/references':
					setTimeout(() => {
						self.prompt([
							'\x1b[36mClick on the items to see sites in action!\x1b[0m',
							'\x1b[32m*** feat. projects ***\x1b[0m',
							'targoncavasarlas.hu | Vue 3 Frontend',
							'autotartosberlet.hu | Angular Frontend',
							'youngart.hu | Vue 3 Frontend',
							'campona.hu | Vue 2 Frontend',
							'Campona App | Ionic - Angular Frontend',
							'feat.agency | Vue 2 Frontend',
							'theduchessbudapest.com | Vue 2 Frontend',
							'spagobudapest.com | Vue 2 Frontend',
							'\x1b[35m*** Private projects:***\x1b[0m',
							'azevirodaja.hu | Vue 2 Frontend',
							'realestateconference.hu | Vue 3 Frontend & Laravel backend',
							'kerteszcentrum.eu | WooCommerce webshop with custom ERP system integration (PHP sync backend)',
						].join('\r\n'));
					}, 200);

					setTimeout(() => {
						self.prompt('\x1b[36mScroll up for the whole list && click on the items to see sites in action!\x1b[0m');
					}, 500);
					break;
				default:
					self.prompt();
				}
			},
			description: 'Prints a fake directory structure',
		},
		clear: {
			f: (terminal: any, self: any, parameter: string) => {
				setTimeout(() => {
					terminal.clear();
					self.prompt();
				}, 200);
			},
			description: 'Clear terminal',
		},
	};


	created() {
		store.sub(TerminalModule.SET_PROMPT, (data) => {
			console.log(data);

			this.term.write(data);
			this.prompt();
		}, false);

		this.term = new Terminal({
			cursorBlink: true,
			cursorStyle: 'bar',
			// logLevel: 'debug',
			rows: 7,
			fontSize: (window as any).innerWidth >= 728 ? 16 : 12,
			theme: {
				background: '#0d1117',
			},
		});

		this.fitAddon = new FitAddon();
	}

	mounted() {
		this.term.loadAddon(new WebLinksAddon());
		this.term.loadAddon(this.fitAddon);
		this.term.open(this.$refs.xterm);

		setTimeout(() => {
			this.fitAddon.fit();
		}, 500);

		this.term.write('Welcome to \x1b[34mMáté Borkesz\x1b[0m\'s CV site! Type \'help\' in the termimal and hit \'Enter\' for more information.');

		this.prompt();
		setTimeout(() => {
			this.term.write('To \x1b[36mread more about the different positions\x1b[0m I filled, click on the \'\x1b[36mPrint to terminal\x1b[0m\' at positions sections.');
		}, 1000);

		setTimeout(() => {
			this.prompt();
		}, 1500);


		this.term.prompt = () => {
			this.term.write('\r\n$ ');
		};

		this.term.onData((e: any) => {
			switch (e) {
			case '\u0003': // Ctrl+C
				this.term.write('');
				this.prompt();
				break;
			case '\r': // Enter
				this.runCommand(this.term, this.command);
				this.command = '';
				break;
			case '\u007F': // Backspace (DEL)
				// Do not delete the prompt
				if (this.term._core.buffer.x > (20 + this.path.length)) {
					this.term.write('\b \b');
					if (this.command.length > 0) {
						this.command = this.command.substr(0, this.command.length - 1);
					}
				}
				break;
			default: // Print all other characters for demo
				if (e >= String.fromCharCode(0x20) && e <= String.fromCharCode(0x7B)) {
					this.command += e;
					this.term.write(e);
				}
			}
		});

		this.registerLinks();
	}


	runCommand(term: any, text: any) {
		const command = text.trim().split(' ')[0];
		const parameter = text.trim().split(' ')[1];
		if (command.length > 0) {
			this.term.writeln('');

			if (command in this.commands) {
				this.commands[command].f(this.term, this, parameter);

				return;
			}

			this.term.writeln(`${command}: command not found`);
		}
		this.prompt();
	}


	prompt(term: string = '') {
		this.command = '';
		this.term.write( term + '\r\n\x1b[32mmate-borkesz-shell\x1b[0m~' + this.path + '\x1b[32m>\x1b[0m');
	}

	registerLinks() {
		for (const link of links) {
			this.term.registerLinkProvider(
				new LinkProvider(
					this.term,
					link.regex,
					link.callback,
					{},
					0,
				),
			);
		}
	}
}
